import { UserActionType } from '@wix/ambassador-funnel-chatbot-v1-session/types';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';
import {
  addToQueue,
  debug,
  handleConflictStatus,
  threeDotsDelay,
} from './utils';

const { clientTopology, queryParams: query } = renderModel.get();

export const sendUserAction = (
  action: UserActionType,
  conversationId: string | undefined,
  nodeId: string | undefined,
  httpClient: HttpClientFactory,
) => {
  return widgetSDK.getContext(renderModel.getUserId()).then((context) => {
    const requestStartedTs = Date.now();
    return httpClient
      .getInstance()
      .post<IInitialChatData>(clientTopology.actionURL, {
        action,
        conversationId,
        nodeId,
        context,
      })
      .then((res) => threeDotsDelay(requestStartedTs).then(() => res))
      .then(handleConflictStatus)
      .then(addToQueue)
      .then(debug)
      .catch(async (error) => {
        const errorMessage = 'fail to post user action';
        logger.log({
          message: errorMessage,
          error,
          callParams: {
            action,
            query,
          },
        });
        return threeDotsDelay(requestStartedTs).then(() =>
          Promise.reject(errorMessage),
        );
      });
  });
};
